import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Mask2Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M25.89 17.5C25.7924 18.6861 25.5729 19.8589 25.235 21H25.85C26.1208 20.4516 26.3579 19.8872 26.56 19.31C26.8036 18.7344 26.9522 18.1232 27 17.5H25.89Z"
        fill="currentColor"
      />
      <path
        d="M9.435 3.54C8.9865 4.01905 8.43636 4.39151 7.825 4.63C7.035 4.975 6.29 5.3 5.48 8.135C4.5405 11.527 4.69 10.45 5.49 14.4C5.495 14.435 5.505 14.47 5.51 14.5H6.805C6.94609 14.0129 7.01185 13.507 7 13C7 9.935 7.54 8.06 8.65 7.26C10.318 6.06 12.186 7.7345 14.5 7.96V2.03C10.86 2.175 10.135 2.87 9.435 3.54Z"
        fill="currentColor"
      />
      <path
        d="M26.52 8.135C25.71 5.3 24.965 4.975 24.175 4.63C21.7075 3.533 22.86 2.2435 17.5 2.03V7.96C19.82 7.734 21.6725 6.055 23.35 7.26C24.46 8.06 25 9.935 25 13C24.9881 13.507 25.0539 14.0129 25.195 14.5H26.49C26.495 14.47 26.505 14.435 26.51 14.4C27.3125 10.44 27.457 11.519 26.52 8.135Z"
        fill="currentColor"
      />
      <path
        d="M24 13C24 10.32 23.585 8.66 22.765 8.07C22.2793 7.77259 21.6774 7.73695 21.16 7.975C19.075 8.67 18.4 8.895 17.5 8.965V14.5H24.165C24.0469 14.009 23.9915 13.505 24 13Z"
        fill="currentColor"
      />
      <path
        d="M7.115 17.5C7.20451 18.6917 7.44304 19.8676 7.825 21H14.5V17.5H7.115Z"
        fill="currentColor"
      />
      <path
        d="M10.84 7.975C10.3226 7.73695 9.72066 7.77259 9.235 8.07C8.415 8.66 8 10.32 8 13C8.00851 13.505 7.95307 14.009 7.835 14.5H14.5V8.965C13.6 8.895 12.925 8.67 10.84 7.975Z"
        fill="currentColor"
      />
      <path
        d="M6.11 17.5H5C5.04792 18.1215 5.19653 18.7311 5.44 19.305C5.64316 19.8835 5.88024 20.4494 6.15 21H6.765C6.42708 19.8589 6.20759 18.6861 6.11 17.5Z"
        fill="currentColor"
      />
      <path
        d="M17.5 17.5V21H24.175C24.557 19.8676 24.7955 18.6917 24.885 17.5H17.5Z"
        fill="currentColor"
      />
      <path
        d="M24 13C24 10.32 23.585 8.66 22.765 8.07C22.2793 7.77259 21.6774 7.73695 21.16 7.975C19.075 8.67 18.4 8.895 17.5 8.965V14.5H24.165C24.0469 14.009 23.9915 13.505 24 13Z"
        fill="currentColor"
      />
      <path d="M17.5 24V29.875C21.065 29.265 22.305 26.45 23.11 24H17.5Z" fill="currentColor" />
      <path d="M8.89 24C9.695 26.45 10.935 29.265 14.5 29.875V24H8.89Z" fill="currentColor" />
      <path
        d="M7.115 17.5C7.20451 18.6917 7.44304 19.8676 7.825 21H14.5V17.5H7.115Z"
        fill="currentColor"
      />
      <path
        d="M10.84 7.975C10.3226 7.73695 9.72066 7.77259 9.235 8.07C8.415 8.66 8 10.32 8 13C8.00851 13.505 7.95307 14.009 7.835 14.5H14.5V8.965C13.6 8.895 12.925 8.67 10.84 7.975Z"
        fill="currentColor"
      />
      <path
        d="M29.5 15.5H16.5V1.5C16.5 1.22386 16.2761 1 16 1C15.7239 1 15.5 1.22386 15.5 1.5V15.5H2.5C2.22386 15.5 2 15.7239 2 16C2 16.2761 2.22386 16.5 2.5 16.5H15.5V22H3C2.72386 22 2.5 22.2239 2.5 22.5C2.5 22.7761 2.72386 23 3 23H15.5V30.5C15.5 30.7761 15.7239 31 16 31C16.2761 31 16.5 30.7761 16.5 30.5V23H29C29.2761 23 29.5 22.7761 29.5 22.5C29.5 22.2239 29.2761 22 29 22H16.5V16.5H29.5C29.7761 16.5 30 16.2761 30 16C30 15.7239 29.7761 15.5 29.5 15.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
